import Image from 'next/image'

import { Card, CardBody } from '@windmill/react-ui'
import { HowItWorksContent } from '../../data/MachineLearningSolutionPageContent'

export const HowItWorks = () => {
    const content = HowItWorksContent
    const { cardData, description, heading } = content
    return (
        <>
            <div>
                <div
                    className="container-sm"
                    itemScope
                    itemType="https://schema.org/WebPage"
                >
                    <Card className="text-center rounded-xl ipad:shadow-none p-10 ipad:p-0 bg-primary-500 ipad:bg-transparent h-[316px] lg:h-[280px] ipad:h-auto">
                        <CardBody>
                            <h2
                                className="text-3xl text-common-white ipad:text-primary-900"
                                itemProp="headline"
                            >
                                {heading}
                            </h2>
                            <p
                                className="text-base text-common-white max-w-[958px] mx-auto text-center mb-11 font-normal ipad:text-interface-900 ipad:mb-0"
                                itemProp="description"
                            >
                                {description}
                            </p>
                        </CardBody>
                    </Card>
                </div>
                <div className="relative grid grid-cols-3 gap-8 -mt-24 ipad:mt-4 ipad:grid-cols-1 ipad:gap-4">
                    {cardData?.length &&
                        cardData.map((item, index) => {
                            return (
                                <Card className="base-card dark" key={index}>
                                    <CardBody className="text-center card-body tablet:text-left">
                                        <span className="block w-16 mx-auto image tablet:w-14">
                                            <Image
                                                src={item?.image?.src}
                                                layout="responsive"
                                                alt={item?.image?.alt}
                                                width={128}
                                                height={128}
                                                itemProp="image"
                                            />
                                        </span>
                                        <div>
                                            <h3
                                                className="title"
                                                itemProp="headline"
                                            >
                                                {item?.heading}
                                            </h3>
                                            <p
                                                className="detail-content"
                                                itemProp="description"
                                            >
                                                {item?.description}
                                            </p>
                                        </div>
                                    </CardBody>
                                </Card>
                            )
                        })}
                </div>
            </div>
        </>
    )
}
